"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Switch = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _excluded = ["classes", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var styles = function styles(theme) {
  return {
    input: {
      opacity: 0,
      width: 0,
      height: 0,
      '&:checked + $slider:before': {
        WebkitTransform: 'translateX(26px)',
        MsTransform: 'translateX(26px)',
        transform: 'translateX(26px)'
      },
      '&:checked + $slider': {
        backgroundColor: theme.palette.primary.dark
      },
      '&:focus + $slider': {
        boxShadow: [0, 0, 10, 'rgba(0,0,0,0.25)', ',', 0, 0, 2, 'rgba(0,0,0,0.5)']
      }
    },
    "switch": {
      position: 'relative',
      display: 'inline-block',
      width: 60,
      height: 34
    },
    slider: {
      borderRadius: 34,
      position: 'absolute',
      cursor: 'pointer',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: theme.palette.secondary.medium,
      WebkitTransition: '.4s',
      transition: '.4s',
      '&:selected': {},
      '&:before': {
        position: 'absolute',
        // boxShadow: [0, 2, 4, 'rgba(0,0,0,0.5)'],
        content: '""',
        height: 26,
        width: 26,
        left: 4,
        bottom: 4,
        backgroundColor: 'white',
        WebkitTransition: '.4s',
        transition: '.4s',
        borderRadius: '50%'
      }
    }
  };
};

var Switch = function Switch(props) {
  var classes = props.classes,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _clsx["default"])(classes["switch"], className)
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: classes.input,
    type: "checkbox"
  }, rest)), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.slider
  }));
};

exports.Switch = Switch;
Switch.defaultProps = {
  classes: {}
};
Switch.propTypes = {
  classes: _propTypes["default"].any,
  className: _propTypes["default"].string
};

var _default = (0, _reactJss["default"])(styles)(Switch);

exports["default"] = _default;